<template>
  <el-drawer v-model="navigation.drawer" direction="rtl" :unique-opened="true" class="k-drawer">
    <div class="d-flex justify-content-center">
      <div>
        <img src="@/assets/logo/logo-reduccion.png" class="img-fluid pl-2" style="width: 120px" />
        <div class="w-100">Superadministrador</div>
      </div>
    </div>
    <el-divider></el-divider>
    <el-menu :router="true" @select="navigation.drawer = false">
      <el-menu-item index="search" :route="userStore.searchersLink" class="menu-item-text">
        <IconHomeSearch></IconHomeSearch>
        Buscadores</el-menu-item
      >

      <el-menu-item index="agencies" route="/sa/agencies" class="menu-item-text">
        <IconMarkups></IconMarkups>
        Agencias</el-menu-item
      >

      <el-menu-item index="bookings" route="/booking" class="menu-item-text">
        <IconBookings></IconBookings>
        Reservas</el-menu-item
      >

      <el-sub-menu index="products">
        <template #title>
          <span class="menu-item-text">
            <IconProduct></IconProduct>
            Producto Kudenix
          </span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="products-1" route="/product/hotel">Hoteles</el-menu-item>
          <el-menu-item index="products-2" route="/product/transfer">Transportes</el-menu-item>

          <el-menu-item index="products-3" route="/product/ticket">Tickets</el-menu-item>
          <el-menu-item index="products-4" route="/product/insurance">Seguros</el-menu-item>
          <el-menu-item index="products-5" route="/place">Lugares</el-menu-item>
        </el-menu-item-group>
      </el-sub-menu>

      <el-menu-item index="users" route="/user" class="menu-item-text">
        <IconUsers></IconUsers>
        Usuarios</el-menu-item
      >

      <el-menu-item index="users" route="/sa/providers-template" class="menu-item-text">
        <IconUsers></IconUsers>
        Plantillas Proveedor</el-menu-item
      >

      <!-- <el-menu-item index="users" route="/sa/providers" class="menu-item-text">
        <IconUsers></IconUsers>
        Proveedores</el-menu-item
      > -->

      <el-menu-item index="whitelabels" route="/whitelabels" class="menu-item-text">
        <IconPages></IconPages>
        White Labels</el-menu-item
      >

      <el-menu-item index="logout" route="/logout" class="menu-item-text">
        <IconLogout></IconLogout>

        Logout</el-menu-item
      >
    </el-menu>
  </el-drawer>
</template>

<script setup>
import { ref, watch } from 'vue'
import IconUsers from '../icons/IconUsers.vue'
import IconBookings from '../icons/IconBookings.vue'
import IconMarkups from '../icons/IconMarkups.vue'
import IconLogout from '../icons/IconLogout.vue'
import IconProduct from '@/components/icons/IconProduct.vue'
import useNavigationStore from '@/stores/navigation.js'
import { useUserStore } from '@/stores/user'
import IconHomeSearch from '../icons/IconHomeSearch.vue'

const navigation = useNavigationStore()
const drawer = ref(navigation.drawer)
const userStore = useUserStore()

watch(navigation.drawer, () => {
  drawer.value = navigation.drawer
})
</script>
